import { useCalendarIssues } from "components/CalendarIssues/context";

import EditIssue from "./components/EditIssue";
import NewIssue from "./components/NewIssue";
import NewTask from "./components/NewTask";
import EditTask from "./components/EditTask";

const EditModal = ({ handleConfirm, close, item, date, type }) => {
  const { refetchTasks, refetchEvents } = useCalendarIssues();

  switch (type) {
    case "edit_issue":
      return (
        <EditIssue
          issue={item}
          refetch={refetchEvents}
          handleConfirm={handleConfirm}
          close={close}
        />
      );
    case "edit_task":
      return (
        <EditTask
          task={item}
          refetch={refetchTasks}
          handleConfirm={handleConfirm}
          close={close}
        />
      );
    case "new_issue":
      return (
        <NewIssue
          date={date}
          refetch={refetchEvents}
          handleConfirm={handleConfirm}
          close={close}
        />
      );
    case "new_task":
      return (
        <NewTask
          date={date}
          refetch={refetchTasks}
          handleConfirm={handleConfirm}
          close={close}
        />
      );
    default:
      return null;
  }
};

export default EditModal;
